import { callEndpoint } from '../backend';
import { getDefaultStartupRoute } from '../route/default-startup-route';
import {
  ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN,
  ROUTE_WEATHER_MOST_RECENT_POSITION,
} from '../route/route-names';
import {
  getUrlForRouteWithGivenParameters,
  transitionToNextRoute,
} from '../route/route-navigation';

export const getWarningDetails = async (id) => {
  const warning = await callEndpoint(callEndpoint.endpoints.getWarning, {
    ':id': id,
  });

  return warning;
};

export const getWarnings = async (latitude, longitude) => {
  const { warnings } = await callEndpoint(
    callEndpoint.endpoints.getWarnings,
    {},
    {
      latitude,
      longitude,
    },
  );
  return warnings;
};

export const isBareMapPath = (pathname) => {
  const normalized = pathname.replace(/\/$/, '') || '/';
  return normalized === '/maps';
};

export const initialize = async () => {
  const [authUrl] = getUrlForRouteWithGivenParameters(
    ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN,
  );

  // Weather-on-startup is only for opening the app on the map home route.
  // Deep links (drop-pin, marketplace, notifications, …) must keep their path.
  if (
    getDefaultStartupRoute() === ROUTE_WEATHER_MOST_RECENT_POSITION &&
    !window.location.href.includes(authUrl) &&
    isBareMapPath(window.location.pathname)
  ) {
    transitionToNextRoute(ROUTE_WEATHER_MOST_RECENT_POSITION);
  }
};
